module.exports = __webpack_public_path__ + "components/incentive/static/speed-a0531a5c1d4a27bdb2a60ecbbd0465a5.svg";